import React, { useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import PublicProfilePage from '../../Components/Profile/PublicProfilePage';
import { getReviewedDemandsAPI } from '../../Store/Actions/demandActions';
import { getPublicMemberProfile } from '../../Services/trustReviews';
import JobModal from './JobModal';
import { isPortfolioPublished, sortPortfolioProjects } from '../../Utils/portfolio';

const CheckArtisanBoutique = ({ userDemands = [], demandsLoading, getDemands }) => {
  const history = useHistory();
  const location = useLocation();
  const artisanId = location.state?.artisanId;
  const [artisan, setArtisan] = useState(null);
  const [profileLoading, setProfileLoading] = useState(Boolean(artisanId));
  const [selectedProject, setSelectedProject] = useState(null);

  useEffect(() => {
    const unsubscribe = getDemands();
    return () => { if (typeof unsubscribe === 'function') unsubscribe(); };
  }, [getDemands]);

  useEffect(() => {
    let active = true;
    if (!artisanId) { setProfileLoading(false); return () => { active = false; }; }
    setProfileLoading(true);
    getPublicMemberProfile(artisanId)
      .then((profile) => { if (active) setArtisan(profile); })
      .catch(() => { if (active) setArtisan(null); })
      .finally(() => { if (active) setProfileLoading(false); });
    return () => { active = false; };
  }, [artisanId]);

  const projects = useMemo(
    () => sortPortfolioProjects(userDemands.filter((demand) => (
      demand?.demand_status === 'reviewed'
      && demand?.contract?.artisan_id === artisanId
      && isPortfolioPublished(demand)
    ))),
    [userDemands, artisanId],
  );

  return (
    <>
      <PublicProfilePage
        profile={artisanId ? artisan : null}
        projects={projects}
        role="artisan"
        loading={Boolean(demandsLoading || profileLoading)}
        onBack={() => history.goBack()}
        onProject={setSelectedProject}
      />
      <JobModal showModal={selectedProject ? 'open' : 'close'} handleClick={() => setSelectedProject(null)} demand={selectedProject} />
    </>
  );
};

const mapStateToProps = ({ demands }) => ({
  demandsLoading: Boolean(demands?.loading),
  userDemands: demands?.demands || [],
});
const mapDispatchToProps = (dispatch) => ({ getDemands: () => dispatch(getReviewedDemandsAPI()) });

export default connect(mapStateToProps, mapDispatchToProps)(CheckArtisanBoutique);
